<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import api from "@/api";
import GameModal from "@/components/GameModal";
import MultiGameModal from "@/components/MultiGameModal";

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    GameModal,
    MultiGameModal,
  },
  // ddddd
  data() {
    return {
      showTooltip: false,
      tooltipPosition: {
        x: 0,
        y: 0,
      },
      startDate: null,
      tooltipString: "",
      activeGame: null,
      gameModal: false,
      activeEvent: null,
      activeEventDialog: false,
      undoing: false,
      timeslotEvents: [],
      items: [],
      selectedTeams: [],
      selectedVenues: [],
      selectedDivisions: [],
      moveOptions: {
        numbers: [],
        units: ["Minutes", "Hours", "Days", "Weeks", "Months"],
      },
      moveChoices: {
        units: "Days",
        amount: 1,
      },
      pastActions: [],
      selectedGames: [],
      schedule: null,
      isLoading: true,
      selectionModal: false,
      selectedEvents: [],
      selectAction: "move", // Moving, Swapping, Removing
      chosenEvents: [],
      calendarOptions: {
        headerToolbar: {
          left: "today,prev,next",
          right: "title",
          center: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        navLinks: true,
        navLinkDayClick: this.clickHeaderDate,
        plugins: [timeGridPlugin, dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        height: "90vh",
        selectable: true,
        selectMinDistance: 50,
        dateClick: this.handleDateClick,
        select: this.handleSelect,
        events: [],
        editable: true,
        eventDrop: this.handleEventDrop,
        eventMouseEnter: this.eventMouseEnter,
        eventMouseLeave: this.eventMouseLeave,
        eventResize: this.handleEventDrop,
        eventClick: this.handleEventClick,
        eventResizableFromStart: true,
        eventResizableFromEnd: true,
      },
    };
  },
  computed: {
    eligibleTeams() {
      console.log("ET", this.selectedDivisions);
      var teams = this.$store.getters.currentSeason.teams;
      if (!this.selectedDivisions.length) {
        return teams;
      } else {
        var results = [];
        teams.forEach(t => {
          if (this.selectedDivisions.includes(t.division_id)) {
            console.log("Push " + t.name);
            results.push(t);
          }
        });
        return results;
      }
    },
    lastAction() {
      if (this.pastActions.length) {
        var x = this.pastActions[this.pastActions.length - 1];
        var str = this.capitalizeFirstLetter(x.action) + " " + x.data.items.length + " games";
        if (x.action == "move") {
          str += " by " + x.data.amount + " " + x.data.units;
        }
        return str;
      } else {
        return undefined;
      }
    },
    selectOptions() {
      return [
        {
          label: `Move Games`,
          value: "move",
        },
        {
          label: `Unschedule Games`,
          value: "remove",
        },
        {
          label: `Swap 2 Games`,
          value: "swap",
        },
      ];
    },
  },
  watch: {
    gameModal: function() {
      if (!this.gameModal) {
        this.activeEvent = null;
      }
    },
  },
  methods: {
    updated(item) {
      console.log("Got updated...", item);
      this.timeslotEvents.forEach((e, i) => {
        if (e.id == item.id) {
          console.log("Found to replace at index " + i);
          this.timeslotEvents.splice(i, 1);
          this.timeslotEvents.push(this.formatItem(item));
        }
      });
      this.gameModal = null;
      this.activeEvent = null;
    },
    clickHeaderDate(date, jsEvent) {
      console.log(date);
      console.log("day", date.toISOString());
      console.log("coords", jsEvent.pageX, jsEvent.pageY);
      this.calendar.getApi().changeView("timeGridDay", date.toISOString());
    },
    mouseMove(e) {
      if (!this.showTooltip) {
        this.tooltipPosition = {
          left: e.clientX - 150 + "px",
          top: e.clientY - 150 + "px",
          position: "fixed",
          zIndex: 2,
          width: "200",
          height: "auto",
          background: "white",
          padding: "20px",
          borderRadius: "5px",
          border: "1px solid rgba(0,0,0,0.55)",
          boxShadow: "box-shadow: 0 1px 2px rgba(0,0,0,0.15)",
        };
      }
    },
    eventMouseEnter(e) {
      console.log(e);
      this.tooltipString =
        e.event.extendedProps.longtitle +
        "<br>" +
        e.event.extendedProps.data.time +
        " at " +
        e.event.extendedProps.data.venue.name +
        " (" +
        e.event.extendedProps.data.surface.name +
        ")";
      this.showTooltip = true;
    },
    eventMouseLeave(e) {
      this.showTooltip = false;
    },
    deleteGame() {
      api
        .deleteTimeslot(this.activeEvent.timeslot.id)
        .then(response => {
          this.makeToast("info", this.$t("Toast.error.delete_game"));
          this.fetchData();
          this.activeEventDialog = false;
          this.activeEvent = null;
        })
        .catch(e => {
          this.makeToast("error", this.$t("Toast.error.delete_timeslot"));
        });
    },
    handleEventClick(eventDropInfo) {
      console.log("EventClick", eventDropInfo.event.extendedProps);
      this.activeEvent = eventDropInfo.event.extendedProps.data;
      this.gameModal = true;
    },
    handleEventDrop(eventDropInfo) {
      console.log(eventDropInfo);
      api
        .updateTimeslot({
          id: eventDropInfo.event.extendedProps.timeslot_id,
          start: eventDropInfo.event.start,
          finish: eventDropInfo.event.end,
        })
        .then(response => {
          this.makeToast("success", this.$t("Toast.error.update_item"));
          this.fetchData();
        })
        .catch(e => {
          console.log("Error", e);
        });
    },
    undoLastMove() {
      this.undoing = true;
      var move = this.pastActions.pop();
      this.selectedGames = move.data.items;
      if (move.action == "swap") {
        this.swapItems();
      } else if (move.action == "move") {
        this.moveChoices.units = move.data.units;
        this.moveChoices.amount = move.data.amount * -1;
        this.moveItems();
      }
    },
    unscheduleItems() {
      api
        .unscheduleItems({
          items: this.selectedGames,
        })
        .then(response => {
          console.log(response);
          this.refresh();
        })
        .catch(e => {
          console.log(e);
        });
    },
    addAction(data) {
      if (this.undoing) {
        this.undoing = false;
      } else {
        this.pastActions.push(data);
      }
    },
    swapItems() {
      api
        .swapScheduleItems({
          items: this.selectedGames,
        })
        .then(response => {
          console.log(response);
          this.addAction({
            action: "swap",
            data: {
              items: this.selectedGames,
            },
          });
          this.refresh();
        })
        .catch(e => {
          console.log(e);
        });
    },
    moveItems() {
      api
        .moveScheduleItems({
          items: this.selectedGames,
          units: this.moveChoices.units,
          amount: this.moveChoices.amount,
        })
        .then(response => {
          console.log(response.data);
          this.addAction({
            action: "move",
            data: {
              items: this.selectedGames,
              units: this.moveChoices.units,
              amount: this.moveChoices.amount,
            },
          });
          this.refresh();
        })
        .catch(e => {
          console.log(e);
        });
    },
    refresh() {
      this.gameModal = false;
      this.selectionModal = false;
      this.fetchData();
      this.selectedEvents = [];
      this.selectedGames = [];
    },
    selectAll() {
      this.selectedGames = [];
      this.selectedEvents.forEach(e => {
        this.selectedGames.push(e.value);
      });
    },
    clearAll() {
      this.selectedGames = [];
    },
    handleSelect(dateInfo) {
      console.log("Selection made: ", dateInfo);
      // Get events within selection range
      this.selectedEvents = [];
      this.timeslotEvents.forEach(e => {
        console.log(e.end);
        // console.log(e);
        if (this.dateWithinRange(e.start, e.end, dateInfo.start, dateInfo.end)) {
          this.selectedEvents.push({
            label: e.title + " (" + this.$moment(e.start).format("llll") + " at " + e.data.timeslot.venue.name + ")",
            value: e.id,
            id: e.id,
          });
          if (this.selectAction != "swap") {
            this.selectedGames.push(e.id);
          }
        }
      });
      this.showTooltip = false;
      this.selectionModal = true;
    },
    handleDateClick(dateInfo) {
      if (this.selectionModal) {
        return;
      }
      this.calendar = this.calendar || this.$refs.fullCalendar;
      if (dateInfo.view.type == "dayGridMonth") {
        this.calendar.getApi().changeView("timeGridWeek", dateInfo.date);
      } else {
        this.startDate = new Date(dateInfo.date).toString();
        this.gameModal = true;
      }
    },
    formatItem(item) {
      return {
        color: item.color,
        textColor: this.invertColor(item.color),
        title:
          (item.game.visitor.shortcode || item.game.visitor.name) +
          " @ " +
          (item.game.home.shortcode || item.game.home.name),
        longtitle: item.game.visitor.name + " @ " + item.game.home.name,
        start: new Date(item.timeslot.start),
        end: new Date(item.timeslot.finish),
        id: item.id,
        timeslot_id: item.timeslot.id,
        data: {
          id: item.id,
          timeslot: item.timeslot,
          schedule_id: item.schedule_id,
          home: {
            name: item.game.home.name,
            id: item.game.home.id,
            score: item.game.home_score,
          },
          visitor: {
            name: item.game.visitor.name,
            id: item.game.visitor.id,
            score: item.game.visitor_score,
          },
          venue: {
            name: item.timeslot.venue.name,
            id: item.timeslot.venue.id,
          },
          surface: item.timeslot.surface,
          week: this.$moment(item.timeslot.start).isoWeek(),
          date: this.$moment(item.timeslot.start).format("MM-DD-YY"),
          time: this.$moment(item.timeslot.start).format("LT"),
        },
      };
    },
    setFilteredGames() {
      console.log("SFG");
      var timeslots = this.filterScheduleItems(
        this.items,
        this.selectedTeams,
        this.selectedDivisions,
        this.selectedVenues,
      );
      this.timeslotEvents = [];
      timeslots.forEach(t => {
        this.timeslotEvents.push(this.formatItem(t));
      });
      this.calendar = this.$refs.fullCalendar;
      console.log(this.timeslotEvents);
      if (!this.currentUser.upgraded) {
        this.timeslotEvents.forEach((item, i) => {
          if (i % 3 != 0) {
            item.title = this.$t('hidden-hidden');
            item.longtitle = this.$t('hidden-at-hidden');
            item.label = "HIDDEN";
            item.blocked = true;
            item.data.home.name = "HIDDEN";
            item.data.visitor.name = "HIDDEN";
            item.data.venue.name = "HIDDEN";
            item.data.surface.name = "HIDDEN";
          }
        });
      }

      this.calendarOptions.events = this.timeslotEvents;
    },
    setItems() {
      // console.log("FilterItems");
      // console.log(this.filterChoice + " " + this.filterString);
      var items = [];

      this.schedule.scheduled_items.forEach(i => {
        var shouldUse = true;
        var str = this.filterString;
        if (str) {
          if (this.filterChoice == "team" && i.game.home.name != str && i.game.visitor.name != str) {
            shouldUse = false;
          }
          if (this.filterChoice == "venue" && i.timeslot.venue.name != str) {
            shouldUse = false;
          }
        }
        if (shouldUse) {
          var x = {};
          if (i.game) {
            x.title = i.game.home.name + " vs. " + i.game.visitor.name;
            x.start = Date.parse(i.timeslot.start);
            x.end = Date.parse(i.timeslot.finish);
            x.venue = i.timeslot.venue;
            x.home = i.game.home;
            x.visitor = i.game.home;
          }
          items.push(x);
        }
      });
      // console.log(this.calendarOptions.events);
      this.calendarOptions.events = items;
    },
    fetchData() {
      console.log("FetchData");
      if (this.$route.params.schedule_id) {
        this.getSchedule();
      } else {
        this.getMasterSchedule();
      }
      this.moveOptions.numbers = [];
      var i = 1;
      while (i < 21) {
        this.moveOptions.numbers.push(i);
        this.moveOptions.numbers.push(-1 * i);
        i++;
      }
    },
    getMasterSchedule() {
      console.log("GMS");
      console.log("Get master schedule for season " + this.$store.getters.currentSeason.id);
      api.getMasterSchedule(this.$store.getters.currentSeason.id).then(response => {
        // this.schedule = response.data;
        this.items = [];

        this.items = response.data.scheduled_items;
        this.isLoading = false;
        this.setFilteredGames();
        // this.setItems();
      });
    },
    getSchedule() {
      api.getSchedule(this.$route.params.schedule_id).then(response => {
        this.schedule = response.data;
        this.items = [];
        this.items = response.data.scheduled_items;
        this.isLoading = false;
        // console.log(this.schedule);
        this.setFilteredGames();
      });
    },
  },
  mounted() {
    setTimeout(() => {
      this.fetchData();
      window.onmousemove = e => {
        this.mouseMove(e);
      };
    }, 500);
    window.analytics.page();
  },
};
</script>

<template>
  <div v-if="isLoading" class="isLoadingDiv">
    <ProgressSpinner />
  </div>
  <div v-else-if="!items.length">
    <h1 class="title">{{ $t("Calendar.master_calendar") }}</h1>
    <h2>{{ $t("Calendar.no_game_schedule") }}</h2>
    <Button @click="goRouter('/schedules/new')" :label="$t('Calendar.create_schedule')" class="p-button-lg p-my-3" />
    <br />or<br /><br />
    <Button class="dsButton p-button-lg p-mb-3" @click="goRouter('/')">
      <span style="color: white">{{ $t("Button.go_to_dashboard") }}</span>
    </Button>
  </div>
  <div v-else-if="items">
    <div class="p-grid">
      <div class="p-col-3 p-lg-2" v-if="$store.getters.currentSeason">
        <Button class="dsButton p-button-lg p-mb-3" @click="goRouter('/')">
          <font-awesome-icon style="color: white" icon="arrow-left" :label="Back"></font-awesome-icon>&nbsp;
          <span style="color: white">{{ $t("dashboard") }}</span>
        </Button>
        <!-- <UpgradeBanner
          v-if="!currentUser.upgraded"
          :message="'Only showing some games on free trial.'"
        /> -->
        <div class="p-mt-3">
          <h2 class="title" @click="fetchData">
            {{ schedule ? schedule.name : "$t('Calendar.master_calendar')" }} Games:
            {{ items.length }}
          </h2>
          <div>
            <div id="tooltip" v-if="showTooltip" v-bind:style="tooltipPosition" style="pointer-events: none">
              <span v-html="tooltipString"></span>
              <br />
              <small>
                <i> {{ $t("Calendar.tooltip.prompt_edit") }} </i></small
              >
            </div>
            <button class="button" @click="gameModal = true">
              {{ $t("Calendar.create_game") }}
            </button>
            <GameModal
              :active="gameModal"
              :start="startDate"
              :input="activeEvent"
              :schedule="schedule"
              v-on:hide="gameModal = false"
              v-on:refresh="refresh"
              v-on:updated="updated"
            ></GameModal>
          </div>
          <div class="p-text-left">
            {{ $t("Calendar.filters") }}
            <br />
            <MultiSelect
              v-model="selectedVenues"
              optionLabel="name"
              optionValue="id"
              @change="setFilteredGames"
              :options="$store.getters.currentSeason.venues"
              :placeholder="$t('Calendar.all_venues')"
            />
            <br />
            <MultiSelect
              v-model="selectedDivisions"
              optionLabel="name"
              optionValue="id"
              @change="setFilteredGames"
              :options="$store.getters.currentSeason.divisions"
              :placeholder="$t('Calendar.all_divisions')"
            />
            <br />
            <MultiSelect
              v-model="selectedTeams"
              optionLabel="name"
              optionValue="id"
              @change="setFilteredGames"
              :options="eligibleTeams"
              :placeholder="$t('Calendar.all_teams')"
            />
          </div>
        </div>
        <div class="p-mt-3" v-if="lastAction">
          <h4 class="title is-5">{{ $t('last-move') }}</h4>
          <p class="p-mb-2">{{ lastAction }}</p>
          <Button :label="$t('Button.undo')" @click="undoLastMove"></Button>
        </div>
      </div>
      <div class="p-col-9 p-lg-10">
        <FullCalendar style="width: 100%" ref="fullCalendar" :options="calendarOptions" />

        <MultiGameModal
          :active="selectionModal"
          :input="selectedEvents"
          v-on:hide="selectionModal = false"
          v-on:refresh="refresh"
        ></MultiGameModal>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.p-multiselect {
  width: 100%;
  margin: 5px auto;
}
</style>
